
import { Sounds } from '../../../@resources/sounds';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Client, ClientManager, Communicator } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { Rect } from '../../../platform/geom/Rect';
import { Camera } from '../../canvas/Camera';
import { escape } from '../../canvas/commands/ManipulationCommands';
import { EditorSession } from '../../canvas/EditorSession';
import { MyRoleInfo } from '../../canvas/MyRoleInfo';
import { PointerInfo } from '../../canvas/PointerInfo';
import { ActiveObject, resolve } from '../../Container';

export class HerdingMechanics extends ActiveObject {

    @resolve(AudioManager) private audio!: AudioManager;
    @resolve(Camera) private camera!: Camera;
    @resolve(ClientManager) private clients!: ClientManager;
    @resolve(Communicator) private comms!: Communicator;
    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(EditorSession) private session!: EditorSession;

    public start(): void {
        this.burden(
            this.comms.recv('herd', this.onHerd)
        );
    }

    private onHerd = async (_sender: Client, data: any) => {
        const { canParticipate } = this.session.get(MyRoleInfo);
        if (!canParticipate) return;
        const frame = Rect.fromArray(data);
        this.dispatch(escape);
        await this.camera.animateToFrame(frame);
        if (this.destroyed()) return;
        const pi = this.session.get(PointerInfo);
        const mpi = this.camera.toModel(pi.position);
        this.clients.self.patch({ px: mpi.x, py: mpi.y });
        if (!!data[4] && data[4] in Sounds) {
            this.audio.play('Herd', Sounds[data[4]], 0.5);
        }
    };
}
